const SkeletonLoader = () => (
  <div className="hidden lg:block animate-pulse space-y-8 max-w-8xl mx-auto mb-12">
    <div className="space-y-8">
      <div className="h-18 flex items-center justify-between gap-12 rounded mt-4">
        <div className="h-12 w-[48px] bg-gray-100 rounded-full"></div>
        <div className="h-12 w-[10%] bg-gray-100 rounded"></div>
        <div className="h-12 w-[10%] bg-gray-100 rounded"></div>
        <div className="h-12 w-[10%] bg-gray-100 rounded"></div>
        <div className="h-12 w-[10%] bg-gray-100 rounded"></div>
        <div className="h-12 w-[10%] bg-gray-100 rounded"></div>
      </div>
      <div className="h-96 bg-gray-100 rounded"></div>
    </div>
    <div className="flex gap-8">
      <div className="h-32 w-1/3 bg-gray-100 rounded"></div>
      <div className="h-80 w-2/3 bg-gray-100 rounded"></div>
    </div>
  </div>
);

export default SkeletonLoader;
